import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getEquipmentPhotos(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].GET_PHOTOS,
		options
	)
}

function _getEquipmentPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].GET_PHOTO,
		options
	)
}

function _putEquipmentPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].PUT_PHOTO,
		options
	)
}

function _patchEquipmentPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].PATCH_PHOTO,
		options
	)
}

function _createEquipmentPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].CREATE_PHOTO,
		options
	)
}

function _deleteEquipmentPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].DELETE_PHOTO,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].GET_PHOTOS]: _getEquipmentPhotos,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].GET_PHOTO]: _getEquipmentPhoto,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].PUT_PHOTO]: _putEquipmentPhoto,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].PATCH_PHOTO]: _patchEquipmentPhoto,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].CREATE_PHOTO]: _createEquipmentPhoto,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].DELETE_PHOTO]: _deleteEquipmentPhoto,
}